module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/radio/asset/checked.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/radio/asset/checked.png
// module id = 1275
// module chunks = 367